import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import {apiDownloadReport, apiPost} from "../../utils/request";
import moment from 'moment';
import {DATE_SHORT_FORMAT, IsNullOrUndefined, REPORTSERVER_BASEURL} from '../../constants';
import injectSheet from 'react-jss';
import AwningColorbondHoodSheet from './AwningColorbondHoodSheet';
import {toastr} from 'react-redux-toastr';
import jQuery from 'jquery';
import { Base64 } from 'js-base64';

const styles = {
  table: { display: 'flex', flexDirection: 'column'},
  tr: { display: 'flex', flexDirection: 'row'},
  td: { display: 'flex', flexDirection: 'column'},
};

class OrderColorbondHoodSheet extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      order: props.order,
      printed: false,
    };

    this.handlePrint = this.handlePrint.bind(this);
    this.printSection = React.createRef();
    this.handleEmail = this.handleEmail.bind(this);
  }

  handlePrint(e, mode = 'print') {

    if(e) {
      e.preventDefault();
    }

    let {order} = this.props;

    let container = jQuery(`<div></div>`);

    jQuery(this.printSection.current).clone().appendTo(container);

    container
      .css('font-size', '12px')
      .css('padding-right', '20px')
      .css('margin-top', '5px')
      .css('padding-top', '25px')
      .css('font-family', "'Open Sans', Arial, sans-serif")
      .css('line-height', "1.6em");

    container.find('h4').css('font-size', '12px');
    container.find('h5').css('font-size', '11px');
    container.find('h6').css('font-size', '10px');
    container.find('.pi-row:first-child').css('margin-top', '0px');
    container.find('.print-hide').remove();
    container.find('input').prop("disabled", false);

    let body = {
      "base64HtmlHead": Base64.encode(document.head.innerHTML),
      "base64HtmlBody": Base64.encode(container[0].innerHTML),
      "pdfOutput": true,
      "isLandscape": false,
      "templateName": "GeneratePdfDefault"
    };

    let fileName = `Order_${order.id}_colorbond_hood.pdf`;

    if(mode==='print'){
      apiDownloadReport(`${REPORTSERVER_BASEURL}/reports/generatepdf`, JSON.stringify(body), fileName);
    } else {
      let _this = this;
      apiDownloadReport(`${REPORTSERVER_BASEURL}/reports/generatepdf`, JSON.stringify(body), fileName, blob => {

        let reader = new FileReader();
        reader.addEventListener("load", function () {
          toastr.info('Sending email...');
          apiPost(`/api/orders/${order.id}/email/colorbondhoodsheet`, {
            content: reader.result,
            fileName: fileName,
            sequenceNumber: order.sequenceNumber,
          }).then(x => {
            if (x.data && x.data.ok) {
              toastr.success('Email sent');
            } else {
              toastr.error('Unable to send email');
            }
          });

        }, false);
        reader.readAsDataURL(blob);
      });
    }

    if(this.props.print) {
      setTimeout(() => {
        this.setState({printed: true});
        this.props.toggleOpen();
      }, 500);
    }
  }

  handleEmail(e){
    this.handlePrint(e, 'email');
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.order || nextProps.order.id != this.state.order.id) {
      this.setState({order: nextProps.order});
    }
    if(nextProps.isOpen && nextProps.print){
      this.setState({printed: false});
    }
  }

  render(){
    let {print, showEmail} = this.props;
    let {order, printed} = this.state;

    if(!order){
      return null;
    }

    let awnings = order.awnings.filter(x => x.hasColorbondHood);

    if(print && !printed) {
      setTimeout(this.handlePrint, 500);
    }

    return (
      <div>

        <Modal isOpen={this.props.isOpen}
               toggle={this.props.toggleOpen}
               style={{minWidth: '940px'}}
        >
          <ModalBody>
            <div className="pi-section">

              <div className="pi-row">
                <div className="pi-col-md-8">
                  <button onClick={this.handlePrint}
                          className="btn pi-btn-base pi-btn-icon-big"
                          style={{marginRight: '10px'}}
                  >
                    <i className="fa fa-print"></i>&nbsp;Print</button>

                  {/*showEmail !== false &&
                    <button onClick={this.handleEmail}
                            className="btn pi-btn-base pi-btn-icon-big"
                            style={{marginRight: '10px'}}
                    >
                      <i className="fa fa-envelope"/>&nbsp;Email</button>
                  */}

                  <button className="btn pi-btn  pi-btn-icon-big"
                          onClick={this.props.toggleOpen}><i className="fa fa-times"></i>&nbsp;Close</button>
                </div>
              </div>

              <div ref={this.printSection}>

                {awnings.map((awning, i) => {
                  return (
                    <div key={awning.id}>
                      <AwningColorbondHoodSheet
                        colorBondColours={this.props.colorBondColours}
                        order={order}
                        awning={awning}
                        ref={`awningColorbondHoodSheet_${awning.id}`}
                        theme={this.props.theme}
                        isFabricationOrder={this.props.isFabricationOrder}
                        user={this.props.user}
                      />
                      { (i + 1) < awnings.length && <div className={'html2pdf__page-break'}></div>}
                    </div>);
                })}

              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="btn pi-btn pi-btn-icon-big"
                    onClick={this.props.toggleOpen}>
              <i className="fa fa-times"></i>&nbsp;Close
            </button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
OrderColorbondHoodSheet.propTypes = {
  order: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleOpen: PropTypes.func.isRequired,
  colorBondColours: PropTypes.array.isRequired,
  print: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  showEmail: PropTypes.bool,
  isFabricationOrder: PropTypes.bool,
  user: PropTypes.object,
};

export default injectSheet(styles)(OrderColorbondHoodSheet);
